import React from 'react';
import PropTypes from 'prop-types';

export default function AriaLevelDiv({
  ariaLevel,
  isFocussable,
  className,
  children,
  tabIndex
}) {
  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
    <div {...(ariaLevel && { 'aria-level': ariaLevel })} className={className} tabIndex={isFocussable ? '0' : tabIndex}>
      {children}
    </div>
  );
}
AriaLevelDiv.propTypes = {
  ariaLevel: PropTypes.string,
  isFocussable: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
  tabIndex: PropTypes.string
};
